import { render, staticRenderFns } from "./personindex.vue?vue&type=template&id=f1d1494e&scoped=true&"
import script from "./personindex.vue?vue&type=script&lang=js&"
export * from "./personindex.vue?vue&type=script&lang=js&"
import style0 from "./personindex.vue?vue&type=style&index=0&id=f1d1494e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d1494e",
  null
  
)

export default component.exports